import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { getInfoBulleMessage, getOptionsCommunes, getOptionsInstalls, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import DoubleFilter from '../component/DoubleFilter';
import SingleFilter from '../component/SingleFilter';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersDoTp = (props: any) => {
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  // const for dropdownlist on change
  const [deversement, setDeversement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('do_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('do_commune')!) || {
      name: '',
      code: '',
    }
  );
  const [type, setType] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('do_type')!) || {
      name: '',
      code: "MDI_DO','MDI_PR,TP",
    }
  );
  const [installations, setInstallations] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('do_installation')!) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [installsOptions, setInstallsOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const infoBulleMessageDataSelectorDoTp = getInfoBulleMessage(props.module);  
 
  // get communes options
  const getCommune = async () => {
    const optionsCommune = await getOptionsCommunes(
      contractCode,
      '50',
      props.module
    );
    if (optionsCommune.length === 0) {
      resetImputLabel('do-filtre-commune');
    }
    setCommuneOptions(optionsCommune);
  };

  // get installs options
  const getInstall = async (pFilters: object) => {
    const res = await getOptionsInstalls(
      defineDefinitionExpression(
        pFilters,
        'modules',
        contractCode
      ),
      '50'
    );
    if (res.length === 0) {
      resetImputLabel('do-filtre-installation');
    }
    setInstallsOptions(res);
  };

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getInstall({
        Color: colorFormated(deversement),
        InseeCode: commune,
        ModelCode: type,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, type, deversement]); // eslint-disable-line react-hooks/exhaustive-deps

  // component did mount
  useEffect(() => {
    // load memory and launch table and map
    props.parentCallback({
      Color: deversement,
      InseeCode: commune,
      ModelCode: type,
      Code: installations,
    });
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='deversement'>
          <Word
            value='Déversement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-deversement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorDoTp}
            sendSelectedColor={(d: any) => {
              setDeversement(d);
              deversement !== '' &&
                props.parentCallback({
                  Color: d,
                  InseeCode: commune,
                  ModelCode: type,
                  Code: installations,
                });
              window.sessionStorage.setItem('do_color', JSON.stringify(d));
            }}
            type='standard'
            sessionStorageName='do_color'
            automatedTestId={[
              'do-temps-sec',
              'do-petite-pluie',
              'do-grosse-pluie',
              'do-pas-de-deversement',
              'do-pas-d’information',
            ]}
          />
        </Container>
        {commune !== null && (
          <DoubleFilter
            module='do'
            titleOne='Communes :'
            filterNameOne='commune'
            filterOneOptions={communeOptions}
            titleTwo='Types :'
            filterNameTwo='type'
            parentCallbackOne={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'do-filtre-installation',
                setInstallsOptions
              );
              props.parentCallback({
                Color: deversement,
                InseeCode: d,
                ModelCode: type,
                Code: {
                  name: '',
                  code: '',
                },
              });
            }}
            parentCallbackTwo={(d) => {
              setType(d);
              props.parentCallback({
                Color: deversement,
                InseeCode: commune,
                ModelCode: d,
                Code: {
                  name: '',
                  code: '',
                },
              });
            }}
          />
        )}
        {installations !== null && (
          <SingleFilter
            module='do'
            title='Installations :'
            filterName='installation'
            filterOptions={installsOptions}
            parentCallback={(d) => {
              setInstallations(d);
              props.parentCallback({
                Color: deversement,
                InseeCode: commune,
                ModelCode: type,
                Code: d,
              });
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersDoTp;
